module.exports = __webpack_public_path__ + "img/flip_horizontal_right.ae9040c6.svg";